import React, { useEffect } from 'react'; 
import loader from './../../assets/cargacaleta.gif'
import './Loader.scss';

/**
 * Componente de Loader
 *
 */
const Loader = ()=>{
    
    useEffect(() => { 
        //window.scrollTo(0,0);
    }, []) 
    return (
        <div className="loader">
            <div className="bg"></div>
            <img src={loader} alt=""/>
        </div>
    )
}
  
export default Loader;